package dev.danko.roblox_craft_ai.shared.model

import kotlinx.serialization.Serializable

@Serializable
data class BillingPlanDto(
    val id: String,
    val name: String,
    /** Null means unlimited. */
    val monthlyCredits: Int? = null,
    val priceCents: Int,
    val currency: String = "USD",
    val paddlePriceId: String? = null,
    val active: Boolean = true
)

@Serializable
data class CreditPackDto(
    val id: String,
    val name: String,
    val credits: Int,
    val priceCents: Int,
    val currency: String = "USD",
    val paddlePriceId: String? = null,
    val active: Boolean = true
)

@Serializable
data class PaddleClientConfigDto(
    val enabled: Boolean,
    val environment: String = "sandbox",
    val clientToken: String? = null
)

@Serializable
data class BillingCatalogDto(
    val plans: List<BillingPlanDto>,
    val packs: List<CreditPackDto>,
    val paddle: PaddleClientConfigDto
)

@Serializable
data class BillingStatusDto(
    val planId: String,
    val subscriptionStatus: String? = null,
    val currentPeriodEndMs: Long? = null,
    val cancelUrl: String? = null,
    val updatePaymentUrl: String? = null
)
